import { render, staticRenderFns } from "./ChangesRelationsModalV2.vue?vue&type=template&id=71a3df3b&"
import script from "./ChangesRelationsModalV2.vue?vue&type=script&lang=js&"
export * from "./ChangesRelationsModalV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports